export default __webpack_public_path__ + "static/media/AmericanTuna.9d968192.jpg";